import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import * as PermissionsActions from './permissions.actions';
import { Permissions } from './permissions.interface';

@Injectable()
export class PermissionsEffects {

	fetchPermissions$ = createEffect(() =>
		this.actions$.pipe(
			ofType(PermissionsActions.fetchPermissions),
			switchMap(() =>
				this.apiService.getBtnPermission().pipe(
					map((res: any) => {
						const permissionResult = JSON.parse(
							res[0]?.['external_summary_side_nav']
						)?.SummaryPermission;

						const permissions: Permissions = {
							pandaDocsAccessRoles: permissionResult?.pandaDocsAccessRoles
								?.split(',')
								?.map(Number) || [],
							checklistAccessRoles: permissionResult?.checklistAccessRoles
								?.split(',')
								?.map(Number) || [],
							underwritingAccessRoles: permissionResult?.underwritingAccessRoles
								?.split(',')
								?.map(Number) || [],
							loanCalculatorAccessRoles: permissionResult?.loanCalculatorAccessRoles
								?.split(',')
								?.map(Number) || [],
							transunionAccessRoles: permissionResult?.transunionAccessRoles
								?.split(',')
								?.map(Number) || [],
							inveriteAccessRoles: permissionResult?.inveriteAccessRoles
								?.split(',')
								?.map(Number) || [],
							loanInterviewAccessRoles: permissionResult?.loanInterviewAccessRoles
								?.split(',')
								?.map(Number) || [],
							exceptionAccessRoles: permissionResult?.exceptionAccessRoles
								?.split(',')
								?.map(Number) || [],
							oldloanCalculatorAccessRoles: permissionResult?.oldloanCalculatorAccessRoles
								?.split(',')
								?.map(Number) || [],
							checklistUser: res[0]?.['checklist']
								?.split(',')
								?.map(Number) || [],
								
						};

						return PermissionsActions.fetchPermissionsSuccess({ permissions });
					}),
					catchError((error) =>
						of(PermissionsActions.fetchPermissionsFailure({ error }))
					)
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private apiService: LegacyApiService
	) {}
}
